import React from "react";

const JQuery_Overview = () => {
  return (
    <div>
      <h1>JQuery_Overview</h1>
      <p>Placeholder component for: "JQuery_Overview"</p>
    </div>
  );
};

export default JQuery_Overview;
